








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'slider-field' })
export default class SliderFieldComponent extends Vue {
  @Prop() public value!: string;
  @Prop() public name!: string;
  @Prop() public placeholder?: string;

  public get innerValue() { return this.value; }
  public set innerValue(val: string) {
    this.$emit('input', val);
  }
}
